module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sentrert_logo_vestfold_telemark_pos.31bd1603.png";